import { businessConfig } from '../config/businessConfig.js';

const displayValue = (value, fallback = 'Sin especificar') => value?.trim() || fallback;

export function buildConsultationMessage({
  customerName,
  serviceName,
  preferredDate,
  timePreference,
  removal,
  extras,
  designNotes,
  hasReference,
}) {
  const extrasText = extras.length > 0 ? extras.join(', ') : 'Ninguno';
  const referenceText = hasReference
    ? 'Sí, enviaré una imagen al abrir la conversación.'
    : 'No por ahora.';

  return [
    `Hola ${businessConfig.founderName}, vi la página de ${businessConfig.businessName} y quisiera consultar disponibilidad.`,
    '',
    `Nombre: ${displayValue(customerName)}`,
    `Servicio: ${displayValue(serviceName)}`,
    `Fecha preferida: ${displayValue(preferredDate)}`,
    `Horario preferido: ${displayValue(timePreference)}`,
    `¿Necesito retiro?: ${removal || 'No'}`,
    `Adicionales: ${extrasText}`,
    `Idea o referencia del diseño: ${displayValue(designNotes, 'Por definir')}`,
    `Imagen de referencia: ${referenceText}`,
    '',
    'Entiendo que la fecha, el horario y el precio final deben ser confirmados por WhatsApp.',
    '¿Cuáles son los datos de transferencia para abonar?',
  ].join('\n');
}

export function buildWhatsAppUrl(message) {
  const phone = businessConfig.whatsappNumber.replace(/\D/g, '');
  const recipient = phone ? `/${phone}` : '/';
  return `https://wa.me${recipient}?text=${encodeURIComponent(message)}`;
}

export function buildReviewMessage({ customerName, serviceName, rating, comment }) {
  return [
    `Hola ${businessConfig.founderName}, quiero compartir una reseña sobre mi experiencia en ${businessConfig.businessName}.`,
    '',
    `Nombre: ${displayValue(customerName)}`,
    `Servicio: ${displayValue(serviceName)}`,
    `Calificación: ${rating}/5 estrellas`,
    `Comentario: ${displayValue(comment)}`,
    '',
    'Autorizo que esta reseña pueda ser revisada y publicada posteriormente por Mujer Virtuosa.',
  ].join('\n');
}
